/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Every page should have a title and a description tag.
 * Some pages will also contain structured page data in json-ld format.
 */

type PageMetaState = {
  title: string;
  description: string;
  structuredData?: Record<string, string>; // TODO: add in the future
};

const initialState: PageMetaState = {
  title: 'Ensembl',
  description: 'The new Ensembl website'
};

const pageMetaSlice = createSlice({
  name: 'page-meta',
  initialState,
  reducers: {
    updatePageMeta(_, action: PayloadAction<PageMetaState>) {
      return action.payload;
    }
  }
});

export const { updatePageMeta } = pageMetaSlice.actions;

export default pageMetaSlice.reducer;
